<template>
  <div id="register">
    <div class="box">
      <!-- <p class="lang">
	  	<el-select
	  	  class="lanselect"
	  	  v-model="language"
	  	  :placeholder="$i18n.t('userinfo').chinese"
	  	  size="mini"
	  	  @change="changeLanguage()"
	  	>
	  	  <el-option :label="$i18n.t('userinfo').chinese" value="zh"></el-option>
	  	  <el-option label="English" value="en"></el-option>
	  	</el-select>
	  </p> -->
      <p class="tip">{{ $t("register_title") }}</p>
      <el-form id="registForm" ref="registForm" :model="registForm" :rules="registRule">
        <el-form-item class="input" prop="user_acct" style="margin-top: .2rem">
          <el-input v-model="registForm.user_acct" :placeholder="$i18n.t('register_user_input')">
            <i slot="prefix" class="iconfont icondaogouyuanx" style="margin-left: 0.05rem"></i>
          </el-input>
        </el-form-item>
        <el-form-item v-if="language == 'zh'" class="input" prop="mobile">
          <el-input v-model="registForm.mobile" :placeholder="$i18n.t('register_mobile_input')">
            <i slot="prefix" class="iconfont iconshoujix" style="margin-left: 0.05rem"></i>
          </el-input>
        </el-form-item>
        <el-form-item v-else class="input" prop="email">
          <el-input v-model="registForm.email" :placeholder="$i18n.t('register_email_input')">
            <i slot="prefix" class="iconfont iconxiaoxix" style="margin-left: 0.05rem"></i>
          </el-input>
        </el-form-item>
        <el-form-item class="input" prop="smsCode">
          <el-col style="width:52%" :span="13">
            <el-input v-model="registForm.smsCode" :placeholder="$i18n.t('register_sms_input')">
              <i slot="prefix" class="iconfont iconyanzhengmax" style="margin-left: 0.05rem"></i>
            </el-input>
          </el-col>
          <el-col style="width:1%" :span="1">&nbsp;</el-col>
          <el-col style="width:46%;text-align: center;" :span="8">
            <el-popover placement="left-end" width="230" v-model="dialogVcode" popper-class="registerHover">
              <el-form id="dialogVcode" ref="dialogVcode">
                <el-form-item class="input" prop="vcode" style="margin-bottom:0;">
                  <img class="vcodeImage" :src="vcodeurl" @click="flashcode()" />
                  <el-input style="width:50%" class="vcodeInput" size="large" v-model="registForm.vcode"
                    :placeholder="$i18n.t('buchong').tips_count_result" />
                </el-form-item>
                <el-button class="btn1 btnsms" type="primary" @click="prevsms()">{{ $t("buchong").sure }}</el-button>
              </el-form>
              <el-button slot="reference" type="primary" :disabled="isSmsEnabled">{{ smsBtnText }}</el-button>
            </el-popover>
          </el-col>
        </el-form-item>
        <el-form-item class="input" prop="password">
          <el-input v-model="registForm.password" type="password" :placeholder="$i18n.t('login_pass_input')">
            <i slot="prefix" class="iconfont iconmimax" style="margin-left: 0.05rem"></i>
          </el-input>
        </el-form-item>
        <el-checkbox class="checkbox is_agree font14" v-model="registForm.is_agree">{{ $t("register_had_read") }}<a
            @click="toagree" class="agree">{{ $t("register_xieyi") }}</a></el-checkbox>
        <el-button class="btn1" type="primary" @click="submit" v-loading="loading">{{ $t("register_button") }}</el-button>
        <p class="register font14">
          <span @click="login">
            {{ $t("register_fast_login") }}
          </span>
        </p>
      </el-form>
    </div>
    <el-dialog :title="$i18n.t('register_question')" :visible.sync="dialogVisible" width="35%" left :modal="true"
      :append-to-body="true">
      <span style="display: block;text-align: center;color:#57AEC9">{{ $t("register_tips") }}</span>
      <img src="../assets/img/kefu.png" width="70%" style="display: block;margin: 0 auto;">
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'register',
  data: function () {
    let confirmPass = (rule, value, callback) => {
      if (value === null) {
        callback(new Error(this.$i18n.t('normal_notnull')))
      } else if (this.registForm.confirm_pwd !== this.registForm.password) {
        callback(new Error(this.$i18n.t('register_repassword')))
      } else {
        callback()
      }
    }
    return {
      registForm: {
        user_acct: null,
        mobile: null,
        email: null,
        password: null,
        smsCode: null,
        confirm_pwd: null,
        vcode: null,
        is_agree: true,
        introducer: null
      },
      language: localStorage.locale,
      visible2: false,
      dialogVisible: false,
      registRule: {},
      counter: 0,
      smsBtnText: this.$i18n.t('register_get_smscode'),
      timer: null,
      vcodemobile: 1,
      randi: 0,
      bgcolor: '#ababab;border:none;',
      loading: false,
      dialogVcode: false,
      r: '',
      t: '',
      vcodeurl: ''
    }
  },
  computed: {
    isSmsEnabled() {
      if (this.language == 'zh') {
        if (this.registForm.mobile == null || this.registForm.mobile === '' || this.registForm.mobile.length !== 11 || this.timer !== null) {
          this.bgcolor = '#ababab;border:none;'
          return true
        }
      } else {
        if (this.registForm.email == null || this.registForm.email === '' || this.timer !== null) {
          this.bgcolor = '#ababab;border:none;'
          return true
        }
      }
      this.bgcolor = '#57AEC9;'
      return false
    }
  },
  watch: {
    counter: function (val) {
      if (val > 0) {
        this.smsBtnText = '(' + val + ')' + this.$i18n.t('register_get_smscode_re')
      } else {
        this.smsBtnText = this.$i18n.t('register_get_smscode')
        if (this.timer) {
          clearInterval(this.timer)
          this.timer = null
        }

      }
    }
  },
  mounted() {
    this.language = localStorage.locale;
    this.smsBtnText = this.$i18n.t('register_get_smscode')
    this.registRule.user_acct = [
      { required: true, message: this.$i18n.t('register_user_input'), trigger: 'blur' }
    ]
    this.registRule.password = [
      { required: true, message: this.$i18n.t('login_pass_input'), trigger: 'blur' }
    ]
    this.registRule.smsCode = [
      { required: true, message: this.$i18n.t('register_sms_input'), trigger: 'submit' }
    ]
    this.is_agree = [
      { required: true, message: this.$i18n.t('register_had_read_first'), trigger: 'blur' }
    ]
    if (this.language == 'en') {
      this.registRule.email = [
        { required: true, message: this.$i18n.t('register_email_input'), trigger: 'blur' }
      ]
    } else {
      this.registRule.mobile = [
        { required: true, message: this.$i18n.t('register_mobile_input'), trigger: 'blur' }
      ]
    }
    this.flashcode();
  },
  methods: {
    flashcode() {
      this.t = new Date().getTime();
      this.r = Math.random();
      this.vcodeurl = "/sms/setVcodeImage?t=" + this.t + "&r=" + this.r;
    },
    prevsms() {
      let _this = this;
      let sure = this.$i18n.t('normal_sure')
      let normal_tips = this.$i18n.t('normal_tips')
      let count_not_right = this.$i18n.t('count_not_right')
      let normal_networkerror = this.$i18n.t('normal_networkerror')
      this.axios({
        method: "post",
        url: "/sms/checkVcode",
        data: { t: this.t, r: this.r, vcode: this.registForm.vcode }
      })
        .then(function (res) {
          console.log(res);
          if (res.data.code == 0) {
            _this.dialogVcode = false;
            _this.sendSms();
          } else {
            _this.$alert(count_not_right, normal_tips, {
              confirmButtonText: sure
            });
            _this.flashcode();
          }
        })
        .catch(function (err) {
          if (err.msg) {
            _this.$alert(err.msg, normal_tips, { confirmButtonText: sure });
          } else {
            _this.$alert(normal_networkerror, normal_tips, {
              confirmButtonText: sure
            });
            _this.flashcode();
          }
        });
    },
    login() {
      this.$router.replace('/login')
    },
    setVcodeMobile() {
      if (this.language == 'zh') {
        if (this.registForm.mobile == null || this.registForm.mobile === '' || this.registForm.mobile.length !== 11) {
          this.$message(this.$i18n.t('register_mobile_notright'))
          return false
        }
      } else {
        if (this.registForm.email == null || this.registForm.email === '') {
          this.$message(this.$i18n.t('register_email_notright'))
          return true
        }
      }
      if (this.visible2 === false && this.vcodemobile !== this.registForm.mobile) {
        console.log('----')
        this.randi += 1
        this.vcodemobile = this.registForm.mobile
      }
    },
    sendSms() {
      if (this.counter > 0) {
        return
      }
      if (this.language == 'zh') {
        if (this.registForm.mobile == null || this.registForm.mobile === '' || this.registForm.mobile.length !== 11) {
          this.$message(this.$i18n.t('register_mobile_notright'))
          return false
        }
        this.visible2 = false
        send(this)
        function send(self) {
          let post = {
            vcode: self.registForm.vcode,
            mobile: self.registForm.mobile,
            biz: 1000,
            src: 10,
            r: self.r,
            t: self.t
          }
          self.axios({
            method: 'post',
            url: '/sms/send',
            data: post
          }).then((response) => {
            let data = response.data
            if (data.code === 0) {
              self.counter = 60
              self.timer = setInterval(() => {
                self.counter = self.counter - 1
              }, 1000)
            } else {
              console.log(data.msg)
              self.$message({
                message: data.msg,
                type: 'warning'
              })
            }
          }).catch(function (err) {
            console.log(err)
          })
        }
      } else {
        let myreg = /^([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+@([a-zA-Z0-9]+[_|\_|\.]?)*[a-zA-Z0-9]+\.[a-zA-Z]{2,3}$/;
        if (
          this.registForm.email === "" ||
          this.registForm.email == null ||
          !myreg.test(this.registForm.email)
        ) {
          this.$message(this.$i18n.t('register_email_notright'))
          return
        }
        this.visible2 = false
        sendEmail(this)
        function sendEmail(self) {
          let post = {
            vcode: self.registForm.vcode,
            email: self.registForm.email,
            biz: 1000,
            src: 10,
            r: self.r,
            t: self.t
          }
          self.axios({
            method: 'post',
            url: '/email/send',
            data: post
          }).then((response) => {
            let data = response.data
            if (data.code === 0) {
              self.counter = 60
              self.timer = setInterval(() => {
                self.counter = self.counter - 1
              }, 1000)
            } else {
              console.log(data.msg)
              self.$message({
                message: data.msg,
                type: 'warning'
              })
            }
          }).catch(function (err) {
            console.log(err)
          })
        }
      }
    },
    submit() {
      if (this.registForm.is_agree !== true) {
        this.$message(this.$i18n.t('register_had_read_first'))
        return false
      }
      this.$refs['registForm'].validate((valid) => {
        if (valid) {
          this.regist()
        } else {
          console.log('error!')
          return false
        }
      })
    },
    regist() {
      this.loading = true
      let post = {
        nickname: this.registForm.user_acct,
        user_acct: this.registForm.user_acct,
        password: this.registForm.password,
        smsCode: this.registForm.smsCode,
        attr: {
          introducer: this.registForm.introducer
        },
        src: 0,
        app_type: 'zmskin'
      }
      if (this.language == 'zh') {
        post.mobile = this.registForm.mobile
      } else {
        post.email = this.registForm.email
      }
      let _this = this
      this.axios({
        method: 'post',
        url: '/userSrv/user/regist',
        data: post
      }).then(function (res) {
        console.log(res)
        if (res.data.code === 0) {
          _this.$message(_this.$i18n.t('register_success'))
          _this.login()
        } else {
          _this.loading = false
          _this.$alert(_this.$i18n.t('error.err_' + res.data.code), _this.$i18n.t('normal_tips'), {
            confirmButtonText: _this.$i18n.t('normal_sure')
          })
        }
      }).catch(function (err) {
        _this.$alert(_this.$i18n.t('normal_networkerror'), _this.$i18n.t('normal_tips'), {
          confirmButtonText: _this.$i18n.t('normal_sure')
        })
        _this.loading = false
      })
    },
    loginFuc() {
      let _this = this
      this.axios({
        method: 'post',
        url: '/auth2/token',
        data: {
          username: this.registForm.mobile,
          password: this.registForm.password,
          client_id: '93dc94c23d83c2ca',
          app_type: 'zmskin',
          code_token: -1
        }
      }).then(function (res) {
        if (res.data.code !== 0) {
          _this.$alert(res.data.msg, _this.$i18n.t('normal_tips'), {
            confirmButtonText: _this.$i18n.t('normal_sure'),
            callback: action => {
              _this.$router.replace('/login')
            }
          })
          _this.loading = false
        } else {
          _this.loading = false
          localStorage.access_token = res.data.access_token
          _this.setCookie('access_token', res.data.access_token, '/', 100000)
          _this.refreashUserInfo()
          _this.$router.push('/skinmgr/home')
        }
      }).catch(function (err) {
        _this.loading = false
        _this.$alert(_this.$i18n.t('normal_networkerror'), _this.$i18n.t('normal_tips'), {
          confirmButtonText: _this.$i18n.t('normal_sure'),
          callback: action => {
            _this.$router.replace('/login')
          }
        })
      })
    },
    toagree() {
      return false
      let url = './static/agree.html'
      window.open(url, '_blank')
    }
  }
}
</script>

<style lang='scss'>
.el-dialog__title {
  display: block;
}

#register {
  .registerHover {
    background: #0a0a0a !important;
    color: #fff !important;

    .popper__arrow::after {
      border-top-color: #0a0a0a !important;
    }
  }

  .el-input__inner {
    height: 0.4167rem;
    line-height: 0.4167rem;
    border: none;
    border-bottom: 1px solid #ccc;
    background: #fff;
    border-radius: 0px;
    padding-left: 0.28rem;
    padding: 0 0.28rem;
    font-size: 0.12rem;
    margin-left: 0.1rem;
  }

  .lang .el-input__inner {
    height: 0.25rem;
    text-align: left;
    padding-left: 0.08rem;
    border: 1px solid #ccc;
  }

  .el-button {
    font-size: 0.12rem
  }

  .el-form-item__content {
    line-height: 0.4167rem;
    font-size: 0.12rem
  }

  .el-button--primary {
    color: #57AEC9;
    background-color: #fff;
    border-color: #57AEC9;
    font-size: 0.12rem;
    width: 6.5vw;
    margin-left: 1vw;
    padding: 0.78vw 0;
  }

  .el-dialog__body {
    height: 285px;
  }

  .el-checkbox__input.is-checked+.el-checkbox__label {
    color: #000;
    font-size: 12px;
  }
}
</style>

<style scoped lang="scss">
#register {
  display: inline-block;
  height: 100%;
  width: 20.8vw;
  position: relative;
  z-index: 10;
  float: right;
  margin-right: 16.6vw;

  .box {
    position: absolute;
    width: 20.8;
    height: 5rem;
    background-color: #fff;
    border-radius: .05rem;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    margin: auto;

    .circle {
      width: 1.3rem;
      height: 1.3rem;
      border-radius: 50%;
      background-color: #fff;
      margin: -.65rem auto 0;
    }

    .tip {
      margin-top: .49rem;
      font-size: 0.25rem;
      letter-spacing: 0.051rem;
      color: #57AEC9;
      text-align: center;
    }

    .input {
      width: 15.6vw;
      height: 0.4167rem;
      margin: 0.15rem auto 0;
      color: #bfbfbf;
      border-radius: none;
    }

    .input1 {
      margin: .33rem auto 0;
    }

    .yanzhengma {
      margin: .3rem .1rem 0 .58rem;
      display: inline-block;
      width: 2.5rem;

      input {
        width: 1.9rem;
      }
    }

    .forget {
      float: left;
      color: $color59;
      margin: .1rem 0 0 .3rem;
      font-size: .14rem;
      cursor: pointer;
    }

    .forget input {
      margin-right: .1rem;
    }

    .btn1 {
      width: 15.6vw;
      height: 0.416rem;
      margin: 0.25rem 2.6vw 0.167rem;
      color: #fff;
      text-align: center;
      font-size: 0.167rem;
      background-color: #57AEC9;
      border: none;
    }

    .btnsms {
      width: 40%;
      float: right;
      margin-top: 0.1rem;
      margin-right: 0.1rem;
      background-color: #fff;
      border-color: #57AEC9
    }

    .is_agree {
      width: 15.6vw;
      margin-left: 2.6vw;
      margin-top: 1vw;
      color: #000;
    }

    .register {
      color: #666;
      font-size: 12px;
      display: inline-block;
      width: auto;
      margin-left: 2.6vw;

      span {
        cursor: pointer;
      }
    }

    .server {
      span {
        cursor: pointer;
      }

      color: #666;
      text-align: right;
      font-size: 12px;
      display: inline-block;
      width: auto;
      float: right;
      margin-right: 2.6vw;
    }

    .agree {
      color: #409eff;
    }

    .agree:hover,
    .register:hover {
      text-decoration: none;
      color: #333;
      cursor: pointer;
    }

    .register i {
      margin-left: .1rem;

    }
  }

  .lanselect {
    width: 0.8rem;
    height: 0.25rem;
    float: right;
    margin-top: 0.1rem;
    margin-right: 0.4rem;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/register.vue